import React from "react"

const Platform = () => {
  return <div>Platforms</div>
}

export default Platform
